class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.links_open = this.querySelectorAll("[data-open-mega-menu]");
    this.header = document.querySelector(".header");
    this.closeButton = this.querySelector(".mega-menu__close");
    this.headerHeight = this.header.offsetHeight;
    this.simpleLinks = this.querySelectorAll(
      ".mega-menu__container .mega-menu__link:not([data-open-mega-menu])"
    );

    this.links_open.forEach((link) => {
      link.addEventListener("mouseover", (e) => {
        e.preventDefault();
        let event = e;
        // Check if mouse stay 1 second on hover on link
        setTimeout(
          function (e) {
            if (link.matches(":hover")) {
              this.toggleMenu(link);
            }
          }.bind(this),
          350
        );
      });
    });

    this.links_open.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });

    this.links_open.forEach((link) => {
      link.addEventListener("toggle", (e) => {
        e.preventDefault();
        this.toggleMenu2(e);
      });
    });

    this.simpleLinks = this.querySelectorAll(
      ".mega-menu__container .mega-menu__link:not([data-open-mega-menu])"
    );

    this.simpleLinks.forEach((link) => {
      link.addEventListener("mouseover", (e) => {
        this.querySelectorAll(".link").forEach((link) => {
          link.classList.remove("active");
        });

        this.querySelectorAll(".mega-menu__panel").forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });

        this.header.classList.remove("header--active");
      });
    });

    document
      .querySelector("#section-w-header")
      .addEventListener("mouseleave", () => {
        this.closeMenu();
      });

    if (window.innerWidth >= 990) {
      this.header.addEventListener("mouseenter", () => {
        this.header.classList.add("header--hover");
        document.querySelector("body").classList.add("shadow");
      });

      this.header.addEventListener("mouseleave", () => {
        this.header.classList.remove("header--hover");
        if (
          !document.querySelector(".header--active") &&
          !document.querySelector("side-cart").classList.contains("open")
        ) {
          document.querySelector("body").classList.remove("shadow");
        }
      });
    }

    this.closeButton.addEventListener("click", () => this.closeMenu());

    this.swiper = [];
    this.querySelectorAll(".header .swiper").forEach((element) =>
      this.initSwiper(element)
    );

    setTimeout(() => {
      console.log(this.header.querySelectorAll(".swiper-button-lock"));
      this.header.querySelectorAll(".swiper-button-lock").forEach((element) => {
        element
          .closest("[data-mega-menu]")
          .querySelector(".swiper-wrapper").style.justifyContent = "center";
      });
    }, 1000);

    this.updateHeaderPosition();
    window.addEventListener("scroll", () => {
      this.updateHeaderPosition();
    });
  }

  toggleMenu(link) {
    let currentLink = link.currentTarget ? link.currentTarget : link;

    let is_main_menu = currentLink.classList.contains("mega-menu__link--main");

    if (this.querySelector(".mega-menu__link--main.active") && is_main_menu) {
      this.querySelector(".mega-menu__link--main.active").dispatchEvent(
        new Event("toggle")
      );
    }

    let menu = currentLink.getAttribute("data-open-mega-menu");
    let menuElement = document.querySelector(`[data-mega-menu="${menu}"]`);
    let parentMenu = document.querySelector(`[data-parent-menu="${menu}"]`);
    let is_open = currentLink.classList.contains("active");

    let panelSecondOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;
    let panelFirstOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;

    if (panelSecondOpen) {
      document
        .querySelectorAll(".mega-menu__panel--second.mega-menu__panel--actif")
        .forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });
    }

    if (panelFirstOpen) {
      document
        .querySelectorAll(
          ".mega-menu__panel--first.mega-menu__panel--actif .link"
        )
        .forEach((panel) => {
          panel.classList.remove("active");
        });
    }

    if (currentLink.classList.contains("active")) {
      currentLink.classList.remove("active");
    } else {
      currentLink.classList.add("active");
    }

    if (menuElement.classList.contains("mega-menu__panel--actif")) {
      menuElement.classList.remove("mega-menu__panel--actif");
      menuElement.querySelectorAll(".link").forEach((link) => {
        link.classList.remove("active");
      });

      parentMenu.classList.remove("mega-menu__panel--actif");
      parentMenu.querySelectorAll(".link").forEach((link) => {
        link.classList.remove("active");
      });
    } else {
      menuElement.classList.add("mega-menu__panel--actif");
    }

    if (this.querySelectorAll(".link.active").length > 0) {
      this.header.classList.add("header--active");
      document.querySelector("body").classList.add("shadow");
    } else {
      this.header.classList.remove("header--active");
      document.querySelector("body").classList.remove("shadow");
    }

    if (is_main_menu && menuElement.querySelector("li [data-open-mega-menu]")) {
      menuElement
        .querySelector("li [data-open-mega-menu]")
        .dispatchEvent(new Event("toggle"));
    }
  }

  toggleMenu2(link) {
    let currentLink = link.currentTarget;

    let menu = currentLink.getAttribute("data-open-mega-menu");
    let menuElement = document.querySelector(`[data-mega-menu="${menu}"]`);
    let parentMenu = document.querySelector(`[data-parent-menu="${menu}"]`);
    let is_open = currentLink.classList.contains("active");
    let panelSecondOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;
    let panelFirstOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;

    if (panelSecondOpen) {
      document
        .querySelectorAll(".mega-menu__panel--second.mega-menu__panel--actif")
        .forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });
    }

    if (panelFirstOpen) {
      document
        .querySelectorAll(
          ".mega-menu__panel--first.mega-menu__panel--actif .link"
        )
        .forEach((panel) => {
          panel.classList.remove("active");
        });
    }

    if (currentLink.classList.contains("active")) {
      currentLink.classList.remove("active");
    } else {
      currentLink.classList.add("active");
    }

    if (menuElement.classList.contains("mega-menu__panel--actif")) {
      menuElement.classList.remove("mega-menu__panel--actif");
      menuElement.querySelectorAll(".link").forEach((link) => {
        link.classList.remove("active");
      });

      parentMenu.classList.remove("mega-menu__panel--actif");
      parentMenu.querySelectorAll(".link").forEach((link) => {
        link.classList.remove("active");
      });
    } else {
      menuElement.classList.add("mega-menu__panel--actif");
    }

    if (this.querySelectorAll(".link.active").length > 0) {
      this.header.classList.add("header--active");
      document.querySelector("body").classList.add("shadow");
    } else {
      this.header.classList.remove("header--active");
      document.querySelector("body").classList.remove("shadow");
    }
  }

  closeMenu() {
    this.querySelectorAll(".link").forEach((link) => {
      link.classList.remove("active");
    });

    this.querySelectorAll(".mega-menu__panel").forEach((panel) => {
      panel.classList.remove("mega-menu__panel--actif");
    });

    this.header.classList.remove("header--active");
    document.querySelector("body").classList.remove("shadow");
  }

  initSwiper(element) {
    if (element.querySelectorAll(".mega-menu__item").length > 5) {
      element.closest("[data-mega-menu]").classList.add("swiper-loaded");
      this.swiper.push(
        new Swiper(element, {
          slidesPerView: "auto",
          spaceBetween: 16,
          freeMode: true,
          navigation: {
            nextEl: element
              .closest("[data-mega-menu]")
              .querySelector(".swiper-button-next"),
            prevEl: element
              .closest("[data-mega-menu]")
              .querySelector(".swiper-button-prev"),
          },
        })
      );
    }
  }

  updateHeaderPosition() {
    if (window.scrollY > 300 && window.innerWidth >= 990) {
      this.header.classList.add("header--scrolled");
      document.querySelector("body").style.paddingTop =
        this.headerHeight + "px";
      document.querySelector("body").classList.add("on-scroll");
      document
        .querySelector("#section-w-header")
        .classList.add("section-header-scrolled");
    } else {
      document.querySelector("body").style.paddingTop = 0;
      document.querySelector("body").classList.remove("on-scroll");
      this.header.classList.remove("header--scrolled");
      document
        .querySelector("#section-w-header")
        .classList.remove("section-header-scrolled");
    }
  }
}

customElements.define("mega-menu", MegaMenu);

class DrawerMenu extends HTMLElement {
  constructor() {
    super();

    this.openButton = document.querySelector(".open-drawer-menu");
    this.closeButton = this.querySelector(".drawer-menu__close");
    this.links_open = this.querySelectorAll("[data-open-mega-menu]");
    this.main_menu = this.querySelector(".drawer-menu__linklists");
    this.return_btn = this.querySelector(".drawer-menu__return");

    this.return_btn_collections = this.querySelectorAll("[data-drawer-return]");

    this.return_btn_collections.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        this.returnMenu(event).bind(this);
      });
    });

    this.openButton.addEventListener("click", () => this.openMenu());
    this.closeButton.addEventListener("click", () => this.closeMenu());

    this.links_open.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.toggleMenu(link).bind(this);
      });
    });

    this.return_btn.addEventListener("click", (event) => {
      this.returnMenu(event).bind(this);
    });
  }

  openMenu() {
    this.classList.add("open");
    document.querySelector("body").classList.add("shadow-drawer");
  }

  closeMenu() {
    this.classList.remove("open");
    document.querySelector("body").classList.remove("shadow-drawer");
  }

  toggleMenu(link) {
    console.log(link);

    let currentLink = link;
    let menu = currentLink.getAttribute("data-open-mega-menu");
    let menuElement = this.querySelector(
      `.mega-menu__panel[data-mega-menu="${menu}"]`
    );

    let parentMenu = currentLink.getAttribute("data-parent-menu");

    if (parentMenu) {
      parentMenu = this.querySelector(
        `.mega-menu__panel[data-mega-menu="${parentMenu}"]`
      );
    }

    console.log(menuElement);

    let panelSecondOpen =
      document.querySelectorAll(
        ".mega-menu__panel--second.mega-menu__panel--actif"
      ).length > 0;
    let panelFirstOpen =
      document.querySelectorAll(
        ".mega-menu__panel--first.mega-menu__panel--actif"
      ).length > 0;

    if (panelSecondOpen) {
      document
        .querySelectorAll(".mega-menu__panel--second.mega-menu__panel--actif")
        .forEach((panel) => {
          panel.classList.remove("mega-menu__panel--actif");
        });
    }

    if (panelFirstOpen) {
      document
        .querySelector(".mega-menu__panel--first.mega-menu__panel--actif")
        .classList.remove("mega-menu__panel--actif");
    }

    this.main_menu.classList.add("hidden");
    menuElement.classList.add("mega-menu__panel--actif");
    this.return_btn.classList.remove("hidden");
  }

  returnMenu(event) {
    event.preventDefault();

    let currentMenu = this.querySelector(".mega-menu__panel--actif");

    if (currentMenu.classList.contains("mega-menu__panel--second")) {
      currentMenu.classList.remove("mega-menu__panel--actif");
      let parentMenu = currentMenu.getAttribute("data-parent-menu");
      parentMenu = this.querySelector(
        `.mega-menu__panel[data-mega-menu="${parentMenu}"]`
      );
      parentMenu.classList.add("mega-menu__panel--actif");
    } else {
      currentMenu.classList.remove("mega-menu__panel--actif");
      this.main_menu.classList.remove("hidden");
      this.return_btn.classList.add("hidden");
    }
  }
}

customElements.define("drawer-menu", DrawerMenu);
